import React from 'react';
import { Icon, Row, Col } from 'antd';
import {
  ResponsiveContainer,
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  Line,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  Legend
} from 'recharts';
import moment from 'moment';

class DashboardView extends React.Component {
  state = {
    year: '2019',
    selectedSubject: null,
    subjectsDisplayedFrom: 0
  };

  getSkillsLogged = () => {
    const { logs } = this.props;
    const { year } = this.state;

    let logsOfYear = logs.filter(
      log => moment(log[1].date).format('YYYY') == year
    );
    let logsPerMonth = [];
    months.map((month, index) => {
      let count = logsOfYear.filter(
        log => moment(log[1].date).format('MM') === month.num
      ).length;
      logsPerMonth.push({
        name: index % 2 === 0 ? month.name : '•',
        value: count
      });
    });
    return {
      logsPerMonth,
      logsOfYear: logsOfYear.length
    };
  };

  getLogsPerCategory = () => {
    const { logs } = this.props;
    let logsPerCategory = [];
    categories.map(category => {
      let count = logs.filter(log => log[1].atl_category.name === category)
        .length;
      logsPerCategory.push({
        name: category,
        value: count
      });
    });
    return logsPerCategory;
  };

  getLogsPerSubject = () => {
    const { logs, subjects } = this.props;
    if (!subjects) {
      return [];
    } else {
      //Filter out unique subjects first
      let subjectsObj = {};
      let logsPerSubject = [];
      subjects.map(subject => {
        subjectsObj[subject[0]] = subject[1].name;
      });
      Object.entries(subjectsObj).map(subject => {
        let count = logs.filter(log => log[1].subject.id === subject[0]).length;
        if (count > 0) {
          logsPerSubject.push({
            name: subject[1],
            amount: count,
            id: subject[0]
          });
          if (!this.state.selectedSubject) {
            this.setState({
              selectedSubject: {
                id: subject[0],
                name: subject[1]
              }
            });
          }
        }
      });
      return logsPerSubject.reverse();
    }
  };

  render() {
    const { logsPerMonth, logsOfYear } = this.getSkillsLogged();
    const logsPerCategory = this.getLogsPerCategory();
    const logsPerSubject = this.getLogsPerSubject();
    const { year } = this.state;
    const { t, color, logs } = this.props;
    const styles = getStyles(color);

    return (
      <div id="student-dashboard">
        <div style={styles.box}>
          <SkillsLoggedChart
            color={color}
            logsOfYear={logsOfYear}
            t={t}
            year={year}
            styles={styles}
            skillsLogged={logsPerMonth}
            switchYear={type =>
              type === 'prev'
                ? this.setState({ year: (Number(year) - 1).toString() })
                : this.setState({ year: (Number(year) + 1).toString() })
            }
          />
        </div>
        <div style={styles.box}>
          <LogsPerCategoryChart
            t={t}
            logsPerCategory={logsPerCategory}
            styles={styles}
            color={color}
          />
        </div>
        <div style={styles.box}>
          <LogsPerSubjectChart
            t={t}
            logsPerSubject={logsPerSubject}
            styles={styles}
            color={color}
            selectedSubject={this.state.selectedSubject}
            selectSubject={subject =>
              this.setState({ selectedSubject: subject })
            }
            subjectsDisplayedFrom={this.state.subjectsDisplayedFrom}
            setSubjectsDisplayedFrom={from =>
              this.setState({ subjectsDisplayedFrom: from })
            }
          />
        </div>
      </div>
    );
  }
}

export default DashboardView;

const SkillsLoggedChart = ({
  skillsLogged,
  t,
  year,
  switchYear,
  logsOfYear,
  styles,
  color
}) => (
  <div>
    <h1 style={styles.title}>{t('Skills Logged')}</h1>
    <div style={styles.yearChanger}>
      <Icon
        type="left"
        onClick={() => switchYear('prev')}
        style={styles.arrow}
      />
      <div>
        <p
          style={{
            fontSize: 20,
            fontFamily: 'Arial Rounded MT Bold',
            marginBottom: 0,
            color,
            textAlign: 'center'
          }}>
          {year}
        </p>
        <p
          style={{
            color,
            fontSize: 18,
            textAlign: 'center',
            fontFamily: 'Helvetica Neue'
          }}>
          {t('Total of')} {logsOfYear} {t('Skills Logged')}
        </p>
      </div>
      <Icon
        style={{
          ...styles.arrow,
          color:
            Number(year) < Number(moment().format('YYYY')) ? color : '#E7E7E7'
        }}
        type="right"
        onClick={() =>
          Number(year) < Number(moment().format('YYYY')) && switchYear('next')
        }
      />
    </div>
    <ResponsiveContainer width="100%" height={350}>
      <LineChart data={skillsLogged}>
        <YAxis
          label={{ fontSize: 8, color: 'red' }}
          dataKey="value"
          allowDecimals={false}
          tickLine={false}
          axisLine={false}
        />
        <XAxis dataKey="name" tickLine={false} axisLine={{ stroke: color }} />
        <CartesianGrid strokeDasharray="3 3" />
        <Line
          dataKey="value"
          stroke={color}
          isAnimationActive={false}
          dot={true}
          strokeWidth={5}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
);

const LogsPerCategoryChart = ({ t, logsPerCategory, styles, color }) => (
  <div>
    <h1 style={styles.title}>{t('Skills Per Category')}</h1>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ fontSize: 16, marginRight: 60 }}>
        {categories.map((category, i) => (
          <div
            style={{
              marginBottom: '20px',
              fontSize: 18,
              fontFamily: 'Helvetica Neue',
              color
            }}>
            <div
              className="circle"
              style={{ backgroundColor: COLORS[i], marginRight: 20 }}
            />{' '}
            {t(category)}
          </div>
        ))}
      </div>
      <PieChart width={340} height={340} id="chart-distribution">
        <Pie
          isAnimationActive={false}
          data={logsPerCategory}
          innerRadius={90}
          outerRadius={160}
          fill="#8884d8"
          labelLine={false}
          paddingAngle={5}
          label={customLabel}>
          {logsPerCategory.map((entry, index) => (
            <Cell fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </div>
  </div>
);

const LogsPerSubjectChart = ({
  t,
  logsPerSubject,
  styles,
  color,
  selectedSubject,
  selectSubject,
  subjectsDisplayedFrom,
  setSubjectsDisplayedFrom
}) => {
  const customeLabelForBar = ({ x, y, value }) => (
    <text
      x={x + 10}
      y={y}
      dy={-15}
      fill="#50cbf5"
      fontSize={10}
      textAnchor="middle">
      {value}
    </text>
  );

  return (
    <div>
      <h1 style={styles.title}>{t('Skills Per Subject')}</h1>
      <div
        style={{
          marginBottom: '15px',
          fontSize: 18,
          fontFamily: 'Helvetica Neue',
          color,
          marginTop: 20
        }}>
        <div
          className="circle"
          style={{ backgroundColor: color, marginRight: 20 }}
        />{' '}
        {selectedSubject && t(selectedSubject.name)}
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end' }}>
        <Icon
          type="left"
          onClick={() =>
            subjectsDisplayedFrom !== 0 &&
            setSubjectsDisplayedFrom(subjectsDisplayedFrom - 9)
          }
          style={{
            ...styles.arrow,
            color: subjectsDisplayedFrom !== 0 ? color : '#E7E7E7'
          }}
        />
        <BarChart
          width={590}
          height={350}
          data={logsPerSubject.slice(
            subjectsDisplayedFrom,
            subjectsDisplayedFrom + 9
          )}>
          <Tooltip />
          <Bar dataKey="amount" label={true} label={customeLabelForBar}>
            {logsPerSubject
              .slice(subjectsDisplayedFrom, subjectsDisplayedFrom + 9)
              .map((item, index) => (
                <Cell
                  background={false}
                  onClick={() =>
                    selectSubject({ id: item.id, name: item.name })
                  }
                  key={`cell-${index}`}
                  fill={
                    selectedSubject && selectedSubject.id === item.id
                      ? color
                      : `${color}9c`
                  }
                  width={20}
                />
              ))}
          </Bar>
          <XAxis dataKey="name" hide={true} />
        </BarChart>
        <Icon
          style={{
            ...styles.arrow,
            color:
              subjectsDisplayedFrom + 9 <= logsPerSubject.length - 1
                ? color
                : '#E7E7E7'
          }}
          type="right"
          onClick={() =>
            subjectsDisplayedFrom + 9 <= logsPerSubject.length - 1 &&
            setSubjectsDisplayedFrom(subjectsDisplayedFrom + 9)
          }
        />
      </div>
    </div>
  );
};

const customLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
  value
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.25;
  const RADIAN = Math.PI / 180;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#ffffff"
      textAnchor={x > cx ? 'start' : 'end'}
      style={{ fontSize: 20, fill: 'white' }}
      dominantBaseline="central">
      {value}
    </text>
  );
};

const getStyles = color => ({
  title: {
    fontSize: 24,
    color,
    fontFamily: 'Arial Rounded MT Bold',
    margin: 0
  },
  box: {
    backgroundColor: 'white',
    width: 675,
    margin: '0 auto',
    borderRadius: 20,
    boxShadow: ' 0 0 4px 0 rgba(0, 0, 0, 0.3)',
    padding: 20,
    marginBottom: 20
  },
  wrapper: {
    backgroundColor: '#485465',
    border: 'none'
  },
  label: {
    fontSize: '11px'
  },
  yearChanger: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  arrow: {
    fontSize: 28,
    color
  }
});

let categories = [
  'Social',
  'Thinking',
  'Research',
  'Communication',
  'Self-Management'
];
const COLORS = ['#541791', '#07B229', '#D8889B', '#002940', '#6C3C11'];

let months = [
  {
    name: 'Jan',
    num: '01'
  },
  {
    name: 'Febr',
    num: '02'
  },
  {
    name: 'Mar',
    num: '03'
  },
  {
    name: 'Apr',
    num: '04'
  },
  {
    name: 'May',
    num: '05'
  },
  {
    name: 'Jun',
    num: '06'
  },
  {
    name: 'Jul',
    num: '07'
  },
  {
    name: 'Aug',
    num: '08'
  },
  {
    name: 'Sept',
    num: '09'
  },
  {
    name: 'Oct',
    num: '10'
  },
  {
    name: 'Nov',
    num: '11'
  },
  {
    name: 'Dec',
    num: '12'
  }
];



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/dashboardView.js